import type { Side } from "./types";

export const getInitialPosition = (side: Side) => {
  switch (side) {
    case "top":
      return { y: 15 };
    case "bottom":
      return { y: -15 };
    case "left":
      return { x: 15 };
    case "right":
      return { x: -15 };
  }
};
